/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 11:07:26
 * @LastEditTime: 2022-06-01 16:04:48
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DeliveryMethod/index.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import {
  deleteDeliveryMethod,
  getDeliveryMethodList,
} from '@/src/request/settings/logistics/deliveryMethod';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin, message } from 'antd';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { columns } from './config';
import css from './css.module.less';

const permissions = () => {
  const add_edit_courier_account_parcel_locker_delivery_method = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation:
          EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
      }),
    ],
  });
  return {
    add_edit_courier_account_parcel_locker_delivery_method,
  };
};
const DeliveryMethod = ({ modalOp }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_courier_account_parcel_locker_delivery_method } =
    permissions();
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const history = useHistory();
  const params: any = useParams();
  const [list, setList] = useState([]);
  const { uuid: warehouseUuid } = params;
  const { loading, run: _getDeliveryMethodList } = useRequest(
    () => getDeliveryMethodList(warehouseUuid),
    {
      onSuccess(result) {
        setList(result);
      },
    },
  );

  const toDeliveryMethodSetting = (uuid: string | undefined) => {
    history.push(
      `/settings/logistics/deliveryMethod/setting/${warehouseUuid}/${
        uuid ? uuid : ''
      }`,
    );
  };

  const { loading: deleteLoading, run: _deleteDeliveryMethod } = useRequest(
    (uuid) => deleteDeliveryMethod(uuid),
    {
      manual: true,
      onSuccess(result) {
        message.success(getI18n('general.deletedsuccessfully'));
        _getDeliveryMethodList();
        setShowModal(false);
      },
    },
  );

  const onAddClick = () => {
    toDeliveryMethodSetting(null);
  };

  const handleDelete = (uuid) => {
    setModalTitle(
      getI18n('storeLogistics.warehouseLocations.deleteDeliveryMethod'),
    );
    setModalContent(
      <div>
        <div className={css.modalContent}>
          {getI18n(
            'storeLogistics.warehouseLocations.deleteDeliveryMethodContent',
          )}
        </div>
        <ModalFooter
          onCancel={() => {
            setShowModal(false);
          }}
          danger
          okText={getI18n('general.delete')}
          onOk={() => _deleteDeliveryMethod(uuid)}
        />
      </div>,
    );
    setShowModal(true);
  };

  return (
    <div>
      <Spin spinning={loading || deleteLoading}>
        <SizeFittingTable
          id='ShippingZoneTable'
          rowKey='uuid'
          pagination={false}
          dataSource={list}
          className={css.shippingZoneTable}
          columns={columns(
            handleDelete,
            toDeliveryMethodSetting,
            !add_edit_courier_account_parcel_locker_delivery_method,
            { getI18n },
          )}
          rowClassName={css.row}
        />
        <Button
          type='primary'
          className={css.button}
          onClick={onAddClick}
          disabled={!add_edit_courier_account_parcel_locker_delivery_method}>
          {getI18n(
            'storeLogistics.destinationAddressLocalisation.addDeliveryMethod',
          )}
        </Button>
      </Spin>
    </div>
  );
};

export default ModalHoc(DeliveryMethod);
